import React from 'react';
import { useTranslation } from 'react-i18next';

import { ActivationStatus } from '../../../utils/activationUtil';
import ErrorLayout from '../../../layouts/ErrorLayout';

export interface IActivationRequiredPageProps {
  status: string;
}

const ActivationRequiredPage: React.FC<IActivationRequiredPageProps> = ({ status }) => {
  const { t } = useTranslation();

  const isExpired = status === ActivationStatus.Expired;
  const title = isExpired ? t('Activation: Expired: Title') : t('Activation: Required: Title');
  const description = isExpired ? t('Activation: Expired: Description') : t('Activation: Required: Description');

  return <ErrorLayout description={description} title={title} />;
};

export default ActivationRequiredPage;
